<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4">
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombres/Apellidos</label>
                <input type="text" v-model="filters.name" class="form-control h-55"
                  placeholder="Ingrese nombres y/o apellidos" />
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Empresa/Institución</label>
                <select v-model="filters.companyId" class="form-select form-control h-55"
                  aria-label="Default select example">
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option :value="company.id" v-for="(company, i) of itemsCompany" :key="i">
                    {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Email</label>
                <input type="text" v-model="filters.email" class="form-control h-55" placeholder="Ingrese email" />
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select v-model="filters.isActive" class="form-select form-control h-55"
                  aria-label="Default select example">
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 text-end">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button type="button" @click.prevent="getPlayers(1)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg">
                  Buscar
                </button>
                <button type="button" @click.prevent="exportToExcel"
                  class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg" :disabled="isLoading">
                  {{ isLoading ? 'Exportando...' : 'Exportar' }}
                </button>
                <RouterLink to="/player/create">
                  <button type="button" class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg">
                    <span class="py-sm-1 d-block">
                      <span>Agregar Jugador</span>
                    </span>
                  </button>
                </RouterLink>
                <button type="button" @click="bulkloadPlayersModal()"
                  class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg">
                  Carga Masiva
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Nombres</th>
                <th scope="col" class="text-center">Apellidos</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Empresa/Institución</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 + (currentPage - 1) * pageSize }}
                </td>
                <td>{{ item.firstName }}</td>
                <td>{{ item.lastName }}</td>
                <td>{{ item.email }}</td>
                <td class="text-body">{{ item.company.name }}</td>
                <td class="text-body text-center">
                  <span @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal" role="button"
                    :class="computeStatusClass(item.isActive)">
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                  </span>
                </td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                <td class="text-center">
                  <div class="">
                    <RouterLink :to="`/player/edit/${item.id}`">
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                  </div>
                  <div class="">
                    <span @click="
                      deletePlayer(item.id, item.firstName, item.lastName)
                      ">
                      <i role="button" class="material-symbols-outlined fs-16 text-primary">
                        delete
                      </i>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination :currentPage="currentPage" :pageSize="pageSize" :totalItems="totalItems"
            @update:page="fetchPage" />
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div id="mdlBulkloadPlayers" class="modal fade" tabindex="-1" aria-labelledby="mdlBulkloadPlayersLabel"
    aria-hidden="true" size="large">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlBulkloadPlayersLabel">
            Carga Masiva de Jugadores
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Empresa/Institución</label>
                <select v-model="formBulkloadPlayers.companyId" @change="clearError('companyId')"
                  class="form-select form-control h-45" aria-label="Default select example">
                  <option :value="null">-- Seleccionar --</option>
                  <option :value="company.id" v-for="(company, i) of itemsCompany" :key="i">
                    {{ company.name }}
                  </option>
                </select>
                <div v-if="errors.companyId" class="input-error">
                  {{ errors.companyId }}
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label><b-link @click="downloadFile()" class="col-md-8"><u class="text-primary"
                      style="cursor: pointer">Descargar Plantilla</u></b-link></label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Archivo</label>
                <FilePond name="playerDataFile" :maxFileSize="'20MB'" :accepted-file-types="supportedFormats"
                  allow-multiple="false" :max-files="1"
                  label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                  :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                  :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                  :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                  :fileValidateTypeLabelExpectedTypes="`El tipo de archivo permitido es: .xlsx`" credits=""
                  @updatefiles="handleUpdateFiles" @input="clearError('playerDataFile')" />
                <div v-if="errors.playerDataFile" class="input-error">
                  {{ errors.playerDataFile }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary text-white" @click="validateForm">
            Guardar
          </button>
          <button type="button" class="btn btn-danger text-white" data-bs-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { playBulkloadSchema } from "@/schemas/playBulkloadSchema";
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import {
  PAGINATION_ITEMS_PER_PAGE,
  STATUS,
  LABELS,
  COMPANY_TYPES,
} from "@/utils/constants";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Players",
  components: {
    Pagination,
    OverlayLoader,
    FilePond,
  },
  setup() {
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const itemsCompany = ref<any[]>([]);
    const items = ref<any[]>([]);
    const filters = ref({
      name: "",
      email: "",
      companyId: null,
      isActive: null,
    });
    const supportedFormats = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const exportToExcel = async () => {
      try {
        isLoading.value = true;

        const params = new URLSearchParams();

        if (filters.value.name) params.append('search', filters.value.name);
        if (filters.value.companyId !== null && filters.value.companyId !== undefined)
          params.append('companyId', String(filters.value.companyId));
        if (filters.value.isActive !== null && filters.value.isActive !== undefined)
          params.append('isActive', String(filters.value.isActive));

        const response: any = await api.get(
          `/reports/players_export?${params}`,
          { responseType: "blob" }
        );

        const contentDisposition = response.headers["content-disposition"] || response.headers["Content-Disposition"];
        let fileName = "jugadores.xlsx";

        if (contentDisposition) {
          let utf8FilenameRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/i;
          let matches = utf8FilenameRegex.exec(contentDisposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          } else {
            let simpleFilenameRegex = /filename\s*=\s*([^;\n]*)/i;
            matches = simpleFilenameRegex.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, "");
            }
          }
        }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        toast.success("Reporte exportado exitosamente", { timeout: 2000 });

      } catch (error) {
        console.error("Error al exportar:", error);
        toast.error("Error al exportar el reporte. Intente nuevamente.", { timeout: 2000 });
      } finally {
        isLoading.value = false;
      }
    };

    const formBulkloadPlayers = ref({
      id: 0,
      companyId: null,
      playerDataFile: null,
    });
    const errors = ref<Record<string, string>>({});
    const modalBulkloadPlayers = ref<any>(null);
    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      await getCompanies();
      await getPlayers(currentPage.value);
      await getBulkloadPlayers();
      const modalElement = document.getElementById("mdlBulkloadPlayers");
      if (modalElement) {
        modalBulkloadPlayers.value = new window.bootstrap.Modal(modalElement);
        modalBulkloadPlayers.value.hide();
      }
    });

    const bulkloadPlayersModal = async () => {
      try {
        resetFilePond();
        formBulkloadPlayers.value.playerDataFile = null;
        formBulkloadPlayers.value.companyId = null;
        modalBulkloadPlayers.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };
    const resetFilePond = () => {
      const removeBtn = document.querySelector(
        ".filepond--file-action-button.filepond--action-remove-item"
      );
      if (removeBtn) {
        (removeBtn as HTMLElement).click();
      }
    };

    const createBulkloadPlayers = async () => {
      try {
        const payload = {
          ...formBulkloadPlayers.value,
        };

        const formData = buildFormData(payload);
        const response = await api.postForm(
          `player/bulkload-players`,
          formData,
          { responseType: "blob" }
        );

        const contentType = response.headers["content-type"];
        if (contentType.includes("application/json")) {
          const data = await response.data.text();
          const json = JSON.parse(data);

          if (json.return) {
            toast.success(`La carga se realizó con éxito.`, { timeout: 2000 });
            resetFilePond();
            formBulkloadPlayers.value.playerDataFile = null;
            formBulkloadPlayers.value.companyId = null;
          } else {
            toast.error(json.message ?? "Error en la carga", { timeout: 2000 });
          }
        } else if (
          contentType.includes(
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          )
        ) {
          resetFilePond();
          formBulkloadPlayers.value.playerDataFile = null;
          formBulkloadPlayers.value.companyId = null;
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "ErroresCargaMasivaJugadores.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();

          toast.error(
            "Algunas filas tienen errores, revisa el Excel descargado",
            {
              timeout: 3000,
            }
          );
        } else {
          toast.error("Tipo de respuesta no esperado", { timeout: 2000 });
        }
      } catch (ex) {
        const err = ex as any;
        if (err.response?.data instanceof Blob) {
          const texto = await err.response.data.text();
          toast.error(texto, { timeout: 2000 });
        } else {
          toast.error(err.response?.data ?? "Error desconocido", {
            timeout: 2000,
          });
        }
      }
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };
    const handleUpdateFiles = (fileItems: any[]) => {
      formBulkloadPlayers.value.playerDataFile = fileItems.length
        ? fileItems[0].file
        : null;
    };
    const downloadFile = async () => {
      try {
        const response = await api.get(`/player/downloadFile`, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "PlantillaPlayers";
        link.click();
      } catch (error) {
        toast.error("Error al descargar el archivo.", {
          timeout: 2000,
        });
        console.error("Error al descargar el archivo", error);
      }
    };
    const validateForm = async () => {
      try {
        errors.value = {};
        await playBulkloadSchema.validate(formBulkloadPlayers.value, {
          abortEarly: false,
          context: { id: formBulkloadPlayers.value.id },
        });
        isLoading.value = true;

        await createBulkloadPlayers();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const getBulkloadPlayers = async () => {
      formBulkloadPlayers.value.companyId = null;
    };

    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PARTICIPANTE}`
        );
        itemsCompany.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getPlayers = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (filters.value.companyId) {
          params = params + `&companyId=${filters.value.companyId}`;
        }
        if (filters.value.email) {
          params = params + `&email=${encodeURIComponent(filters.value.email)}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/player?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getPlayers(currentPage.value);
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${status ? "desactivar" : "activar"
          }</b> el Jugador?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/player`, obj);

        if (response != 0) {
          toast.success(
            `El jugador fue ${status ? "desactivado" : "activado"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `El jugador no pudo ser ${status ? "desactivado" : "activado"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    const deletePlayer = async (
      idPlayer: number,
      firstName: string,
      lastName: string
    ) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>eliminar</b> al Jugador ${firstName + " " + lastName
          }?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, eliminar`,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;
        const response: any = await api.delete(`/player?id=${idPlayer}`);

        if (response != 0) {
          toast.success(`El Jugador fue eliminado con éxito.`, {
            timeout: 2000,
          });
          fetchPage(currentPage.value);
        } else {
          toast.error(`El Jugador no pudo ser eliminado.`, {
            timeout: 2000,
          });
        }
        isLoading.value = false;
      }
    };
    return {
      items,
      itemsCompany,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      formBulkloadPlayers,
      isLoading,
      clearError,
      computeStatusClass,
      getPlayers,
      fetchPage,
      confirmChangeStatus,
      deletePlayer,
      bulkloadPlayersModal,
      handleUpdateFiles,
      supportedFormats,
      createBulkloadPlayers,
      downloadFile,
      errors,
      validateForm,
      exportToExcel,
    };
  },
});
</script>
